import React from "react";
import PropTypes from "prop-types";
import { getVUSExtra } from "../../../../../../common/helpers/helpers";

const VerdictText = ({ localStateVerdict }) => {
  const { verdict, clinical_score: score } = localStateVerdict;

  if (!score) return <span>{verdict}</span>;

  const { sub_verdict: vusSubVerdict, tooltip: vusTooltip } =
    getVUSExtra(score) ?? {};

  if (!vusSubVerdict) {
    return <span>{verdict}</span>;
  }
  return (
    <span>
      {verdict}{" "}
      <span data-tooltip={vusTooltip}>
        {typeof localStateVerdict.total_score === "number"
          ? `${localStateVerdict.total_score} pts`
          : vusSubVerdict}
      </span>
    </span>
  );
};

VerdictText.propTypes = {
  localStateVerdict: PropTypes.shape({
    benign_score: PropTypes.number,
    benign_subscore: PropTypes.string,
    clinical_score: PropTypes.number,
    pathogenic_score: PropTypes.number,
    pathogenic_subscore: PropTypes.string,
    total_score: PropTypes.number,
    verdict: PropTypes.string,
  }).isRequired,
};

export default VerdictText;
